export default "__VITE_ASSET__hA0Swmzu__"